import React from 'react';
import { forecasts } from '../../data/forecasts';
import { clients } from '../../data/clients';
import { CloudSnow, Clock, TrendingUp, AlertTriangle } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
export function ForecastList() {
  const sortedForecasts = [...forecasts].sort((a, b) => a.eventStart.getTime() - b.eventStart.getTime());
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-345">
      <div className="p-6 border-b border-gray-200" data-id="element-346">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-347">
          Prévisions de neige
        </h2>
        <p className="text-sm text-gray-600 mt-1" data-id="element-348">
          {forecasts.length} événements prévus
        </p>
      </div>
      <div className="divide-y divide-gray-200" data-id="element-349">
        {sortedForecasts.map(forecast => {
        const client = clients.find(c => c.id === forecast.clientId);
        if (!client) return null;
        const duration = (forecast.eventEnd.getTime() - forecast.eventStart.getTime()) / (1000 * 60 * 60);
        return <div key={forecast.id} className="p-6 hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-350">
              <div className="flex items-start justify-between" data-id="element-351">
                <div className="flex-1" data-id="element-352">
                  <div className="flex items-center space-x-3 mb-2" data-id="element-353">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${forecast.intensity === 'forte' ? 'bg-red-100' : forecast.intensity === 'modérée' ? 'bg-orange-100' : 'bg-blue-100'}`} data-id="element-354">
                      <CloudSnow className={`w-5 h-5 ${forecast.intensity === 'forte' ? 'text-red-600' : forecast.intensity === 'modérée' ? 'text-orange-600' : 'text-blue-600'}`} data-id="element-355" />
                    </div>
                    <div data-id="element-356">
                      <h3 className="text-sm font-semibold text-gray-900" data-id="element-357">
                        {client.name}
                      </h3>
                      <p className="text-xs text-gray-500" data-id="element-358">
                        {client.address.street}, {client.address.city}
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4" data-id="element-359">
                    <div className="flex items-center space-x-2" data-id="element-360">
                      <Clock className="w-4 h-4 text-gray-400" data-id="element-361" />
                      <div data-id="element-362">
                        <p className="text-xs text-gray-500" data-id="element-363">Début</p>
                        <p className="text-sm font-medium text-gray-900" data-id="element-364">
                          {format(forecast.eventStart, 'dd MMM, HH:mm', {
                        locale: fr
                      })}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2" data-id="element-365">
                      <Clock className="w-4 h-4 text-gray-400" data-id="element-366" />
                      <div data-id="element-367">
                        <p className="text-xs text-gray-500" data-id="element-368">Fin</p>
                        <p className="text-sm font-medium text-gray-900" data-id="element-369">
                          {format(forecast.eventEnd, 'dd MMM, HH:mm', {
                        locale: fr
                      })}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4 mt-4" data-id="element-370">
                    <div className="flex items-center space-x-2" data-id="element-371">
                      <TrendingUp className="w-4 h-4 text-gray-400" data-id="element-372" />
                      <span className="text-sm text-gray-700" data-id="element-373">
                        {forecast.accumulation.min}-{forecast.accumulation.max}{' '}
                        cm (méd: {forecast.accumulation.median} cm)
                      </span>
                    </div>
                    <div className="flex items-center space-x-2" data-id="element-374">
                      <span className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded-full" data-id="element-375">
                        {forecast.probability}% probabilité
                      </span>
                      <span className={`text-xs px-2 py-1 rounded-full ${forecast.intensity === 'forte' ? 'bg-red-100 text-red-700' : forecast.intensity === 'modérée' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-376">
                        {forecast.intensity}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="ml-4" data-id="element-377">
                  {forecast.triggeredIntervention ? <div className="flex items-center space-x-2 px-3 py-1.5 bg-green-100 text-green-700 rounded-lg" data-id="element-378">
                      <AlertTriangle className="w-4 h-4" data-id="element-379" />
                      <span className="text-xs font-medium" data-id="element-380">
                        Intervention déclenchée
                      </span>
                    </div> : <div className="px-3 py-1.5 bg-gray-100 text-gray-600 rounded-lg" data-id="element-381">
                      <span className="text-xs font-medium" data-id="element-382">En attente</span>
                    </div>}
                  <div className="mt-2 text-right" data-id="element-383">
                    <p className="text-xs text-gray-500" data-id="element-384">SLA</p>
                    <p className="text-sm font-semibold text-gray-900" data-id="element-385">
                      {client.slaHours}h
                    </p>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}